import React from "react";
import SectionHeading from "./SectionHeading";
import { ABOUT_HIGHLIGHTS, ABOUT_PARAGRAPHS, HOW_I_WORK } from "./data/content";
import Jas from "./Images/Jas.png";
import { useIntersectionObserver } from "./useIntersectionObserver";

function About() {
  const ref = React.useRef(null);
  const [inView] = useIntersectionObserver(ref);

  return (
    <section
      id="about"
      className={"site-section" + (inView ? " section-is-visible" : "")}
      ref={ref}
    >
      <div className="section-inner">
        <SectionHeading
          label="About"
          title="Who I am & how I work"
          description="Full-stack developer focused on polished UI, thorough debugging, and learning by building. Rails and Vue/Nuxt day to day."
        />

        <div className="about-layout reveal-item">
          <div className="about-portrait glass-card">
            <div className="about-portrait-frame">
              <img src={Jas} alt="Jas Sabharwal" loading="eager" decoding="async" />
            </div>
            <p className="about-portrait-caption">Full-stack developer · Southern Ontario area</p>
          </div>

          <div className="about-content">
            <div className="about-highlights">
              {ABOUT_HIGHLIGHTS.map((item) => (
                <div key={item.label} className="about-highlight glass-card">
                  <span className="about-highlight-label">{item.label}</span>
                  <span className="about-highlight-value">{item.value}</span>
                </div>
              ))}
            </div>

            <div className="about-bio glass-card">
              {ABOUT_PARAGRAPHS.map((paragraph) => (
                <p key={paragraph.slice(0, 24)}>{paragraph}</p>
              ))}
            </div>

            <div className="about-approach">
              {HOW_I_WORK.map((item) => (
                <div
                  key={item.title}
                  className={"about-approach-card glass-card about-approach-card--" + item.accent}
                >
                  <h3 className="about-approach-title">{item.title}</h3>
                  <p className="about-approach-desc">{item.description}</p>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}

export default About;
